// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { TeamView } from '../components/team';
import { CardView } from '../lib/layout';

export default function Team() {
  return (
    <CardView title="Team">
      <Helmet>
        <title>{'Microgreen Manager Team'}</title>
        <meta name="description" content={'Meet the team who are creating Microgreen Manager.'} />
      </Helmet>
      <TeamView />
    </CardView>
  );
}
